import { useContext, useEffect } from "react";
import { datalayer } from "../datalayer";
import { channelsContext } from "../../channels/constants/contexts";
import {
    BCPPYME,
    CALL_BCPPYME,
    CALLCENTER,
    BCP,
} from "../../channels/constants/channels";
import { partners } from "../constants/partners";

export const useDatalayerInit = () => {
    const channels = useContext(channelsContext);

    useEffect(() => {
        let payload = null;
        const channel = channels ? channels.channel : "";

        switch (channel) {
            case BCP:
                payload = {
                    partnerType: partners.bcp,
                    partner: partners.bcp,
                };
                break;
            case BCPPYME:
                payload = {
                    partnerType: partners.bcp,
                    partner: partners.bcppyme,
                };
                break;
            case CALL_BCPPYME:
                payload = {
                    partnerType: partners.bcp,
                    partner: partners.callcenter,
                };
                break;
            case CALLCENTER:
                payload = {
                    partnerType: partners.pacifico,
                    partner: partners.callcenter,
                };
                break;
        }
        datalayer.initDefault(payload);
    }, []);
};
